import React from 'react';
import { XCircle } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function ProblemsSection() {
  const scrollToPricing = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const problems = ['Compraste productos incorrectos y gastaste dinero sin ver resultados profesionales.', 'Miraste cientos de videos en YouTube pero nadie explica el proceso completo paso a paso.', 'No sabés cuánto cobrar por un trabajo ni cómo armar un presupuesto.', 'Tenés miedo de arruinar la pintura de un auto por no usar las técnicas adecuadas.'];
  return <section className="bg-black text-white py-20 px-4 relative overflow-hidden border-y-8 border-[#D4AF37]" data-id="element-209">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-20" data-id="element-210"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-211">
        <h2 className="text-3xl md:text-5xl font-black text-center mb-12 text-balance uppercase leading-tight" data-id="element-212">
          Si querés empezar en el detailing,{' '}
          <span className="text-red-500" data-id="element-213">probablemente te pasó esto:</span>
        </h2>

        <div className="space-y-6 mb-12" data-id="element-214">
          {problems.map((problem, index) => <div key={index} className="flex items-start gap-4 bg-gray-900/80 p-6 rounded-xl border border-gray-800 hover:border-red-500/50 transition-colors" data-id="element-215">
              <XCircle className="w-8 h-8 text-red-500 flex-shrink-0 mt-1" data-id="element-216" />
              <p className="text-lg md:text-xl font-medium text-gray-300 leading-relaxed" data-id="element-217">
                {problem}
              </p>
            </div>)}
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-black p-8 rounded-2xl border border-[#D4AF37]/30 text-center mb-12 shadow-[0_0_30px_rgba(212,175,55,0.1)]" data-id="element-218">
          <p className="text-xl md:text-2xl font-bold text-white leading-relaxed" data-id="element-219">
            El problema <span className="text-[#D4AF37]" data-id="element-220">no es el mercado</span>{' '}
            ni la falta de oportunidades. El problema es intentar aprender sin
            un sistema claro y probado que te guíe paso a paso.
          </p>
        </div>

        <div className="text-center" data-id="element-221">
          <CTAButton text="DESCUBRÍ LA SOLUCIÓN" onClick={scrollToPricing} className="w-full md:w-auto md:min-w-[350px]" data-id="element-222" />
        </div>
      </div>
    </section>;
}